import { Link } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';

export default function Footer() {
  const { isKannada } = useLanguage();
  return (
    <footer className="bg-[#1a1a2e] text-gray-400 text-sm" data-testid="footer">
      <div className="max-w-[1400px] mx-auto px-4 py-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          <div>
            <h4 className="text-white font-bold mb-3 text-xs uppercase tracking-wider">{isKannada ? 'ವಿಭಾಗಗಳು' : 'Sections'}</h4>
            {[{p:'/category/cat_politics',kn:'ರಾಜಕೀಯ',en:'Politics'},{p:'/category/cat_business',kn:'ವ್ಯಾಪಾರ',en:'Business'},{p:'/category/cat_sports',kn:'ಕ್ರೀಡೆ',en:'Sports'},{p:'/category/cat_entertainment',kn:'ಮನರಂಜನೆ',en:'Entertainment'}].map(l=>(
              <Link key={l.p} to={l.p} className="block py-1 hover:text-white transition-colors">{isKannada?l.kn:l.en}</Link>
            ))}
          </div>
          <div>
            <h4 className="text-white font-bold mb-3 text-xs uppercase tracking-wider">{isKannada ? 'ಇನ್ನಷ್ಟು' : 'More'}</h4>
            {[{p:'/category/cat_technology',kn:'ತಂತ್ರಜ್ಞಾನ',en:'Technology'},{p:'/category/cat_culture',kn:'ಸಂಸ್ಕೃತಿ',en:'Culture'},{p:'/category/cat_local',kn:'ಸ್ಥಳೀಯ ಸುದ್ದಿ',en:'Local'}].map(l=>(
              <Link key={l.p} to={l.p} className="block py-1 hover:text-white transition-colors">{isKannada?l.kn:l.en}</Link>
            ))}
          </div>
          <div>
            <h4 className="text-white font-bold mb-3 text-xs uppercase tracking-wider">{isKannada ? 'ಮಾಹಿತಿ' : 'Info'}</h4>
            <span className="block py-1">{isKannada ? 'ನಮ್ಮ ಬಗ್ಗೆ' : 'About Us'}</span>
            <span className="block py-1">{isKannada ? 'ಸಂಪರ್ಕಿಸಿ' : 'Contact'}</span>
          </div>
          <div>
            <img src="/logo.svg" alt="Taaynadu" className="h-10 mb-3 brightness-0 invert opacity-50" />
            <p className="text-xs text-gray-500">{isKannada ? 'ಕನ್ನಡಿಗರ ನಂಬಿಕೆಯ ಸುದ್ದಿ ಮೂಲ' : "Karnataka's trusted news source"}</p>
          </div>
        </div>
        <div className="border-t border-gray-700 mt-6 pt-4 text-center text-xs text-gray-600">&copy; {new Date().getFullYear()} Taaynadu News</div>
      </div>
    </footer>
  );
}
